// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story-container {
  background-color: white;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  transition: all 1s ease;
  max-height: 100%;
  box-shadow: darkgreen;
  border:solid;
  border-width: 1.5px;
  border-color: rgba(21, 204, 36, 0.664);

}

.story-container.wrong{
  border-color: rgba(204, 21, 21, 0.664);
}


.story-container.open {
  transition: all 1s ease;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/StoryContainer/StoryContainer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;;AAExC;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,uBAAuB;AACzB","sourcesContent":[".story-container {\n  background-color: white;\n  padding: 10px;\n  margin: 10px;\n  border-radius: 10px;\n  transition: all 1s ease;\n  max-height: 100%;\n  box-shadow: darkgreen;\n  border:solid;\n  border-width: 1.5px;\n  border-color: rgba(21, 204, 36, 0.664);\n\n}\n\n.story-container.wrong{\n  border-color: rgba(204, 21, 21, 0.664);\n}\n\n\n.story-container.open {\n  transition: all 1s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
